import { ChangeEvent, FC, Dispatch, SetStateAction } from 'react';
import { Box } from '@mui/material';

import { fontWeight, Heading, Text } from '../../../../../../packages/ui/atoms/typography';
import { iconBtnType, IconButton } from '../../../../../../packages/ui/molecules/icon-button';
import { Textarea } from '../../../../../../packages/ui/atoms/textarea';

import { useStyles } from './Notes.styles';

const Notes = ({ onClose, notes, setNotes }) => {
  const classes = useStyles();

  const onChangeText = e => {
    setNotes(e.target.value);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Box className={classes.headerText}>
          <Heading weight={fontWeight.BOLD} className={classes.title}>
            Scratchpad
          </Heading>
          <Text className={classes.subtitle} weight={fontWeight.MEDIUM}>
            Notes here are only for you and only for the current session.
          </Text>
        </Box>
        <IconButton icon="close" onClick={onClose} className={classes.closeBtn} />
      </Box>

      <Box className={classes.body}>
        <Textarea
          value={notes}
          onChange={onChangeText}
          placeholder="Enter your notes"
          className={classes.textarea}
        />
      </Box>
      <Box className={classes.footer}>
        <Box />
        <IconButton onClick={onClose} variant={iconBtnType.PRIMARY} className={classes.doneBtn}>
          Done
        </IconButton>
      </Box>
    </Box>
  );
};

export { Notes };
